import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { WebhooksCard } from "@/modules/admin";

export default function AdminWebhooksPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.webhooks.pageTitle")}
      description={t("admin.webhooks.pageDescription")}
    >
      <PermissionGate
        perm="org.update"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <WebhooksCard />
      </PermissionGate>
    </AppLayout>
  );
}
